"use client";

import { BsArrowClockwise, BsExclamationOctagon } from "react-icons/bs";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <section className="bg-secondary-light text-white md:pt-[80px] md:pb-[80px] h-[80vh] flex items-center">
      <div className="container">
        <div className="md:grid grid-cols-5 gap-5">
          <div></div>

          <div className=" bg-white shadow-lg p-8 rounded-lg md:mb-0 mb-5 col-span-3 w-[75%] mx-auto group">
            <span className="w-[60px] mx-auto h-[60px] bg-gradient-to-r from-primary-main to-primary-dark flex items-center justify-center rounded-full relative before:absolute before:w-[80px] before:h-[80px] before:rounded-full before:bg-primary-main before:opacity-15">
              <BsExclamationOctagon className="text-5xl text-white relative " />
            </span>

            <h1 className="text-3xl mt-12 text-center font-bold text-primary-main ">
              Something Went Wrong
            </h1>

            <button
              type="button"
              onClick={
                // Attempt to recover by trying to re-render the invoices route
                () => reset()
              }
              className="  overflow-y-hidden  mt-5 mx-auto bg-white py-2 px-6 border border-secondary-dark  font-semibold rounded-full flex items-center relative  before:absolute before:bottom-0 before:left-0 before:bg-primary-main before:translate-y-12 group-hover:before:translate-y-0 before:transition-all before:w-full before:h-full before:rounded-full"
            >
              <p className="relative flex items-center group-hover:text-white  text-secondary-dark text-sm">
                <BsArrowClockwise className="text-xl mr-2" /> Retry
              </p>
            </button>
          </div>

          <div></div>
        </div>
      </div>
    </section>
  );
}
